
export const searchIndex: SearchItem[] = [
  // — Pages principales —
  {
    id: "admin-dashboard",
    href: "/dashboard/admin",
    type: "page",
    labelKey: "safecheck.nav.dashboard",
    categoryKey: "search.pages",
    keywords: ["dashboard", "tableau de bord", "admin", "accueil", "home"],
  },
  {
    id: "statistics",
    href: "/dashboard/statistics",
    type: "page",
    labelKey: "safecheck.nav.globalStatistics",
    categoryKey: "search.pages",
    keywords: ["statistiques", "statistics", "rapports", "analytics", "graphiques"],
  },
  {
    id: "requests",
    href: "/dashboard/requests",
    type: "page",
    labelKey: "safecheck.nav.requests",
    categoryKey: "search.pages",
    keywords: ["autorisation", "authorization", "demandes", "urgence", "requests"],
  },

  // — Utilisateurs & prestataires —
  {
    id: "users",
    href: "/dashboard/users",
    type: "page",
    labelKey: "safecheck.nav.allAccounts",
    categoryKey: "search.pages",
    keywords: ["utilisateurs", "users", "comptes", "accounts", "admin"],
  },
  {
    id: "providers",
    href: "/dashboard/providers",
    type: "page",
    labelKey: "safecheck.nav.allProviders",
    categoryKey: "search.pages",
    keywords: ["prestataires", "providers", "hopital", "hôpital", "clinique", "pharmacie"],
  },
  {
    id: "employees",
    href: "/dashboard/employees",
    type: "page",
    labelKey: "safecheck.nav.allEmployees",
    categoryKey: "search.pages",
    keywords: ["employes", "employés", "assurés", "employees", "agents", "personnel"],
  },
  {
    id: "beneficiaries",
    href: "/dashboard/beneficiaries",
    type: "page",
    labelKey: "safecheck.nav.beneficiaries",
    categoryKey: "search.pages",
    keywords: ["beneficiaires", "beneficiaries", "ayants droit", "patients"],
  },

  // — Factures —
  {
    id: "all-invoices",
    href: "/dashboard/invoices",
    type: "page",
    labelKey: "safecheck.nav.allInvoices",
    categoryKey: "search.pages",
    keywords: ["factures", "invoices", "facturation", "billing"],
  },
  {
    id: "approved-invoices",
    href: "/dashboard/invoices/approved",
    type: "page",
    labelKey: "safecheck.nav.approvedInvoices",
    categoryKey: "search.pages",
    keywords: ["factures approuvees", "approved", "validees", "validées"],
  },
  {
    id: "rejected-invoices",
    href: "/dashboard/invoices/rejected",
    type: "page",
    labelKey: "safecheck.nav.rejectedInvoices",
    categoryKey: "search.pages",
    keywords: ["factures rejetees", "rejected", "refusees", "refusées"],
  },

  // — Forfaits & conventions —

  // — Actes médicaux —
  {
    id: "consult-acts",
    href: "/dashboard/acts/standard-codes",
    type: "page",
    labelKey: "safecheck.nav.consultActs",
    categoryKey: "search.pages",
    keywords: ["actes", "consulter", "codes", "standards", "medical acts", "ccam"],
  },
  {
    id: "hospital-acts",
    href: "/dashboard/acts/by-hospital",
    type: "page",
    labelKey: "safecheck.nav.hospitalActs",
    categoryKey: "search.pages",
    keywords: ["actes hopital", "actes par hôpital", "hospital acts"],
  },
  {
    id: "category-validation",
    href: "/dashboard/acts/category-validation",
    type: "page",
    labelKey: "safecheck.nav.categoryValidation",
    categoryKey: "search.pages",
    keywords: ["validation", "categories", "catégories", "classification"],
  },

  // — Système —
  {
    id: "backup-create",
    href: "/dashboard/backup/create",
    type: "page",
    labelKey: "safecheck.nav.createBackup",
    categoryKey: "search.pages",
    keywords: ["sauvegarde", "backup", "créer", "create", "export", "donnees"],
  },
  {
    id: "backup-restore",
    href: "/dashboard/backup/restore",
    type: "page",
    labelKey: "safecheck.nav.restoreBackup",
    categoryKey: "search.pages",
    keywords: ["sauvegarde", "backup", "restauration", "restore", "donnees"],
  },
  {
    id: "system-logs",
    href: "/dashboard/system-logs",
    type: "page",
    labelKey: "safecheck.nav.systemLogs",
    categoryKey: "search.pages",
    keywords: ["logs", "journal", "systeme", "système", "audit trail"],
  },
  {
    id: "cache",
    href: "/dashboard/cache",
    type: "page",
    labelKey: "safecheck.nav.cacheManagement",
    categoryKey: "search.pages",
    keywords: ["cache", "memoire", "mémoire", "performance"],
  },

  // — Tableaux de bord par rôle —
  {
    id: "auditor-dashboard",
    href: "/dashboard/auditor",
    type: "page",
    labelKey: "safecheck.nav.auditorDashboard",
    categoryKey: "search.pages",
    keywords: ["auditeur", "auditor", "controle", "contrôle"],
  },
  {
    id: "hospital-dashboard",
    href: "/dashboard/hospital",
    type: "page",
    labelKey: "safecheck.nav.hospitalDashboard",
    categoryKey: "search.pages",
    keywords: ["hopital", "hôpital", "hospital", "etablissement"],
  },
  {
    id: "enterprise-dashboard",
    href: "/dashboard/enterprise",
    type: "page",
    labelKey: "safecheck.nav.enterpriseDashboard",
    categoryKey: "search.pages",
    keywords: ["entreprise", "enterprise", "societe", "société", "ceec"],
  },

  // — Actions rapides —
  {
    id: "add-user",
    href: "/dashboard/users/create",
    type: "widget",
    labelKey: "safecheck.nav.addUser",
    categoryKey: "search.actions",
    keywords: ["ajouter utilisateur", "nouveau compte", "create user"],
  },
  {
    id: "add-provider",
    href: "/dashboard/providers/create",
    type: "widget",
    labelKey: "safecheck.nav.addProvider",
    categoryKey: "search.actions",
    keywords: ["ajouter prestataire", "nouveau prestataire", "create provider"],
  },
  {
    id: "submit-invoice",
    href: "/dashboard/invoices/submit",
    type: "widget",
    labelKey: "safecheck.nav.submitInvoice",
    categoryKey: "search.actions",
    keywords: ["soumettre facture", "nouvelle facture", "submit invoice"],
  },

  // — Indicateurs dashboard —
  {
    id: "invoices-review",
    href: "/dashboard/invoices/pending",
    type: "widget",
    labelKey: "safecheck.adminDashboard.indicators.inReview",
    categoryKey: "search.indicators",
    keywords: ["en examen", "review", "a traiter", "à traiter"],
  },
  {
    id: "invoices-approved-kpi",
    href: "/dashboard/invoices/approved",
    type: "widget",
    labelKey: "safecheck.adminDashboard.indicators.approved",
    categoryKey: "search.indicators",
    keywords: ["approuvees", "approuvées", "validated"],
  },
  {
    id: "platform-providers",
    href: "/dashboard/providers",
    type: "widget",
    labelKey: "safecheck.adminDashboard.metrics.providers",
    categoryKey: "search.indicators",
    keywords: ["prestataires actifs", "reseau", "réseau"],
  },
  {
    id: "platform-beneficiaries",
    href: "/dashboard/beneficiaries",
    type: "widget",
    labelKey: "safecheck.adminDashboard.metrics.beneficiaries",
    categoryKey: "search.indicators",
    keywords: ["beneficiaires actifs", "couverture sante"],
  },
];
